/**
 * Modify the behaviour of clicking heading permalinks.
 */
document.querySelectorAll('.js-heading-permalink').forEach((link) => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        const hash = e.target.getAttribute('href');
        history.pushState(null, null, hash);
    });
});
